module.exports = __webpack_public_path__ + "img/coupon_zhCn.9b71b2fe.png";